import React from "react";
import Snackbar from "@mui/material/Snackbar";
import { Alert } from "@mui/material";

const defaultAnchorOrigin = {
  vertical: "bottom",
  horizontal: "center",
};

function AppSnackbar({
  open,
  text,
  type = "success",
  autoHideDuration = 4000,
  anchorOrigin = defaultAnchorOrigin,
  onClose,
  hideWhenEmpty = true,
}) {
  if (hideWhenEmpty && !text) {
    return null;
  }

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
    >
      <Alert onClose={onClose} severity={type} sx={{ width: "100%" }}>
        {text}
      </Alert>
    </Snackbar>
  );
}

export default AppSnackbar;
